var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-row',{staticClass:"text-center",attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","sm":"12","md":"10","lg":"8","xl":"8"}},[_c('AllowpartnerComponent',{attrs:{"languagestrings":_vm.languagestrings,"toperror":_vm.toperror,"baseUrl":_vm.baseUrl}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }